import React from 'react'
import Service from '../Service/Service'
import './Services.css'

function Services() {
  return (
    <div className='Services'>

    <Service />
    </div>
  )
}

export default Services